export default __webpack_public_path__ + "static/media/audio.d69faa32.svg";